import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AdobeExperiencePlatform',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AdobeExperiencePlatform_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AdobeExperiencePlatform_DisplayText)
    ]
})
export class AdobeExperiencePlatformLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_APIKey
    })
    public apiKey?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountID
    })
    public accountId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_OrgID
    })
    public orgId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_PrivateKeyContent,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public privateKeyContent?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
